
import { ColorSystem } from '../colors/color';

export type Button2Styles = {
    borderRadius: string,
    variants:{
        outlined:ButtonVariantStyles
    }
}

export type ButtonVariantStyles = {
    default: ButtonVariantStateStyles,
    hover: ButtonVariantStateStyles,
    active: ButtonVariantStateStyles,
    disabled: ButtonVariantStateStyles,
}

export type ButtonVariantStateStyles = {
    border:string,
    background:string,
    color:string
}

export function button2Styles(colors:ColorSystem): Button2Styles 
{
    return {
        borderRadius: '4px',
        variants:{
            outlined:{
                default: {
                    border: `1px solid ${colors.button2.outlined.default.border}`,
                    background: colors.button2.outlined.default.background,
                    color: colors.button2.outlined.default.text,
                },
                hover: {
                    border: `1px solid ${colors.button2.outlined.hover.border}`,
                    background: colors.button2.outlined.hover.background,
                    color: colors.button2.outlined.hover.text,
                },
                active: {
                    border: `1px solid ${colors.button2.outlined.active.border}`,
                    background: colors.button2.outlined.active.background,
                    color: colors.button2.outlined.active.text,
                },
                disabled: {
                    border: `1px solid ${colors.button2.outlined.disabled.border}`,
                    background: colors.button2.outlined.disabled.background,
                    color: colors.button2.outlined.disabled.text,
                },
            }
        }
    };
}